import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

export const OrderConfirmErrorRedirect: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;
    toast.error(t("orderConfirmation.somethingWentWrong"));
    navigate("/order/place");
  }, [navigate, t]);

  return null;
};
